import { ExchangeId, ProductType, OrderType, OrderStatus, SecurityType, OptionMode, OhlcInterval, BrokerConnectionStatus } from '../../utProto/enums_pb';
import { WebApiStrategyRunningType, WebApiStrategyOrderExeType, WebApiStrategyResponseType, TriggerType } from '../../utProto/webApiStrategyEnums_pb';
import { OrderMode as OrderModeEnum } from '../../utProto/enums_pb';
import { WebAlertCondition } from '../../utProto/webAlertStructureEnums_pb';
import {PlanType, RiskOMeterValues} from '../../utProto/webEnums_pb';
import { Utils } from '@app/_helpers';

export const ORDER_STATUS = {
  [OrderStatus.ORDERSTATUS_PENDING]: 'PENDING',
  [OrderStatus.ORDERSTATUS_CONFIRMED]: 'CONFIRMED',
  [OrderStatus.ORDERSTATUS_FILLED]: 'FILLED',
  [OrderStatus.ORDERSTATUS_CANCELED]: 'CANCELLED',
  [OrderStatus.ORDERSTATUS_REPLACED]: 'REPLACED',
  [OrderStatus.ORDERSTATUS_NEW_REJECTED]: 'NEW REJECTED',
  [OrderStatus.ORDERSTATUS_CANCEL_REJECTED]: 'CANCEL REJECTED',
  [OrderStatus.ORDERSTATUS_REPLACE_REJECTED]: 'REPLACE REJECTED',
  [OrderStatus.ORDERSTATUS_FROZEN]: 'FROZEN',
  [OrderStatus.ORDERSTATUS_PARTIALLY_FILLED]: 'PARTIALLY FILLED',
  [OrderStatus.ORDERSTATUS_CANCELED_OF_IOC]: 'CANCELLED IOC',
  [OrderStatus.ORDERSTATUS_RMS_REJECT]: 'RMS REJECT',
  [OrderStatus.ORDERSTATUS_PENDING_NEW]: 'PENDING NEW',
  [OrderStatus.ORDERSTATUS_PENDING_REPLACE]: 'PENDING REPLACE',
  [OrderStatus.ORDERSTATUS_PENDING_CANCEL]: 'PENDING CANCEL',
  [OrderStatus.ORDERSTATUS_SUSPENDED_CONFIRMED]: 'SUSPENDED CONFIRMED',
  [OrderStatus.ORDERSTATUS_SUSPENDED_REPLACED]: 'SUSPENDED REPLACED',
  [OrderStatus.ORDERSTATUS_RESTATED]: 'RESTATED',
  [OrderStatus.ORDERSTATUS_AMO_CONFIRMED]: 'AMO PENDING',
  [OrderStatus.ORDERSTATUS_MARKET_TO_LIMIT]: 'CONFIRMED',
}

export enum MarketIDMap {
  BSECM = ExchangeId.EXCHANGEID_BSECM,
  BSEFO = ExchangeId.EXCHANGEID_BSEFO,
  NSECM = ExchangeId.EXCHANGEID_NSECM,
  NSEFO = ExchangeId.EXCHANGEID_NSEFO,
  ESMNSE = ExchangeId.EXCHANGEID_ESMNSE,
  ESM = ExchangeId.EXCHANGEID_ESMNSE,
  NSECDS = ExchangeId.EXCHANGEID_NSECDS,
  BSECDS = ExchangeId.EXCHANGEID_BSECDS,
  MSECD = ExchangeId.EXCHANGEID_MSECD,
  MSEFO = ExchangeId.EXCHANGEID_MSEFO,
  MSECM = ExchangeId.EXCHANGEID_MSEICM,
  PLUS = ExchangeId.EXCHANGEID_PLUS,
  MCX = ExchangeId.EXCHANGEID_MCX,
}

export const MarketIDRevMap = {
  [ExchangeId.EXCHANGEID_BSECM]: 'BSECM',
  [ExchangeId.EXCHANGEID_BSEFO]: 'BSEFO',
  [ExchangeId.EXCHANGEID_NSECM]: 'NSECM',
  [ExchangeId.EXCHANGEID_NSEFO]: 'NSEFO',
  [ExchangeId.EXCHANGEID_ESMNSE]: 'ESMNSE',
  [ExchangeId.EXCHANGEID_NSECDS]: 'NSECDS',
  [ExchangeId.EXCHANGEID_BSECDS]: 'BSECDS',
  [ExchangeId.EXCHANGEID_MSECD]: 'MSECD',
  [ExchangeId.EXCHANGEID_MSEFO]: 'MSEFO',
  [ExchangeId.EXCHANGEID_MSEICM]: 'MSEICM',
  [ExchangeId.EXCHANGEID_PLUS]: 'PLUS',
  [ExchangeId.EXCHANGEID_MCX]: 'MCX'
}

export enum OrderMode {
  BUY = 'Buy',
  SELL = 'Sell'
}

export enum PAUSE_LABEL {
  PAUSE = 'Pause',
  RESUME = 'Resume'
}

export enum STREAM_TYPE {
  BACKTEST = 'backtest',
  ALERTS = "alerts",
  ORDERS = "orders",
  STRATEGY = 'strategy',
  SYMBOLADDED = 'symbolAdded',
  SYMBOLPOSITIONUPDATED = 'symbolPositionUpdated',
  SYMBOLDELETED = 'symbolDeleted',
  LISTALGOS = 'listAlgos',
  STATUS = 'status',
  BROKER = 'broker',
  SQUAREOFF = 'squareOff',
  SUBSCRIPTION = 'subscription',
  TRANSACTIONS = 'transactions',
  AUTH = 'auth',
  MARGINBUCKET = 'marginBucket',
  INFRASTATUS = 'infraStatus',
  GLOBALEXIT = 'globalExit',
  NOTIFICATIONS = 'notifications',
  AUTODEPLOYMENT = 'autoDeployment',
  AI_ASSISTANT = 'aiAssistant',
  ACCOUNT_USAGE = 'accountUsage',
  CHAT_NOTIFICATION = 'notification',
  CLIENT_MTM_UPDATE = 'clientMTMUpdate',
  BROKER_CONNECTION_UPDATE = 'brokerConnectionUpdate',
  BROKER_LOGIN_UPDATE = 'brokerLoginUpdate',
  BROKER_CREDENTIALS_UPDATE = 'brokerCredentialUpdate',
  BROKER_CONNECTION_SNAPSHOT = 'brokerConnectionSnapshot'
}

export enum SIDEBAR_BUBBLE_EVENTS {
  ALERT = 'Alert',
  BOOKS = 'Books'
}

export const INSTRUMENT_MAP = {
  C: 'Common Stock',
  F: 'Future',
  O: 'Option'
}

export enum ALERT_TYPE {
  LIVE = WebApiStrategyRunningType.WEBAPISTRATEGYRUNNINGTYPE_LIVE,
  FORWARD = WebApiStrategyRunningType.WEBAPISTRATEGYRUNNINGTYPE_PAPERTRADE,
  BACKTESTING = WebApiStrategyRunningType.WEBAPISTRATEGYRUNNINGTYPE_BACKTESTING
}

export enum ORDER_MODE {
  BUY = OrderModeEnum.ORDERMODE_BUY,
  SELL = OrderModeEnum.ORDERMODE_SELL
}

export const ORDER_MODE_STRING = {
  [OrderModeEnum.ORDERMODE_BUY]: 'Buy',
  [OrderModeEnum.ORDERMODE_SELL]: 'Sell',
}


export const OPTION_MODE_STRING = {
  [OptionMode.OPTIONMODE_PUT]: 'PE',
  [OptionMode.OPTIONMODE_CALL]: 'CE',
}


export enum ORDER_MODE_ENUM {
  BUY = 'BUY',
  SELL = 'SELL'
}

export enum ORDER_CONDITION {
  ENTRY = WebAlertCondition.ALERTCONDITION_ENTRY,
  EXIT = WebAlertCondition.ALERTCONDITION_EXIT,
  REPAIR = WebAlertCondition.ALERTCONDITION_REPAIR,
  BID = WebAlertCondition.ALERTCONDITION_BID,
  HEDGE = WebAlertCondition.ALERTCONDITION_HEDGE,
  LOAD = WebAlertCondition.ALERTCONDITION_LOAD,
  UNLOAD = WebAlertCondition.ALERTCONDITION_UNLOAD,
  MSO = TriggerType.TRIGGERTYPE_MULTIPLIER_SQUARE_OFF,
}

export enum ORDER_CONDITION_ENUM {
  ENTRY = 'ENTRY',
  EXIT = 'EXIT',
  REPAIR = 'REPAIR',
  BID = 'BID',
  HEDGE = 'HEDGE',
  LOAD = 'LOAD',
  UNLOAD = 'UNLOAD',
  MSO = 'MSO'
}

export enum PRODUCT_TYPE_NUM {
  INTRADAY = ProductType.PRODUCTTYPE_INTRADAY,
  DELIVERY = ProductType.PRODUCTTYPE_DELIVERY,
  CARRYFORWARD = ProductType.PRODUCTTYPE_CARRYFORWARD,
}

export const ORDER_TYPE_ENUM = new Utils.TwoWAyDict({
  'Market': OrderType.ORDERTYPE_MARKET,
  'Limit': OrderType.ORDERTYPE_LIMIT,
  'Stop Loss Market': OrderType.ORDERTYPE_STOP,
  'Stop Loss Limit': OrderType.ORDERTYPE_STOP_LIMIT,
}).getDict();


export enum MODE_OF_EXCUTION {
  'Offline' = WebApiStrategyOrderExeType.WEBAPISTRATEGYORDEREXETYPE_OFFLINE,
  'Semi Automatic' = WebApiStrategyOrderExeType.WEBAPISTRATEGYORDEREXETYPE_SEMI_AUTOMATED,
  'Automatic' = WebApiStrategyOrderExeType.WEBAPISTRATEGYORDEREXETYPE_AUTOMATED
}


export enum InterceptorErrorType {
  EMAILNOTVERIFIED = 1,
  MAXRESENDOTPATTEMPTS,
  EMAILALREADYREGISTERED,
  PHONENOALREADYREGISTERED
}

export enum ALGO_STATUS {
  ACTIVE = 'Active',
  COMPLETE = 'Complete',
  PAUSED = 'Paused',
  SAVE_ONLY = 'Save Only'
}

export enum CHART_TYPE {
  PORTFOLIO = 'Portfolio Level',
  ALGO = 'Algo Level',
  SYMBOL = 'Symbol Level'
}

export const ExecutionType = {
  'Live Trading': WebApiStrategyRunningType.WEBAPISTRATEGYRUNNINGTYPE_LIVE,
  'Forward Testing': WebApiStrategyRunningType.WEBAPISTRATEGYRUNNINGTYPE_PAPERTRADE
}

export enum StrategyState {
  RUNNING = WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_SUCCESSFUL,
  PAUSED = WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_PAUSE_STRATEGY_SUCCESS,
  TERMINATED = WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_TERMINATE_SUCCESS
}

export enum FEE_SCHEDULES_STRINGS {
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly',
  YEARLY = 'Yearly'
}


export const PLAN_FREQUENCY = {
  'Daily': 'DAILY',
  'Weekly': 'WEEKLY',
  'Monthly': 'MONTHLY',
  'Yearly': 'YEARLY'
}

export const PLAN_TYPE_OPTIONS = {
  'One Time' : PlanType.PLANTYPE_ONETIME,
  'Forever' : PlanType.PLANTYPE_FOREVER
}


export enum CandleIntervals {
  '1m' = OhlcInterval.OHLCINTERVAL_1_MIN,
  '3m' = OhlcInterval.OHLCINTERVAL_3_MIN,
  '5m' = OhlcInterval.OHLCINTERVAL_5_MIN,
  '10m' = OhlcInterval.OHLCINTERVAL_10_MIN,
  '15m' = OhlcInterval.OHLCINTERVAL_15_MIN,
  '30m' = OhlcInterval.OHLCINTERVAL_30_MIN,
  '1h' = OhlcInterval.OHLCINTERVAL_1_HOUR,
  '4h' = OhlcInterval.OHLCINTERVAL_4_HOUR,
  '1d' = OhlcInterval.OHLCINTERVAL_1_DAY,
  '5d' = OhlcInterval.OHLCINTERVAL_5_DAYS,
  '1M' = OhlcInterval.OHLCINTERVAL_1_MONTH
}

export enum PNL_ENUM {
  Instrument = 'Instrument',
  TargetPNL = 'Target P&L',
  TargetPrice = 'Target Price',
  EntryPrice = 'Entry Price',
  LTP = 'LTP'
}

export enum CUSTOM_TOASTR_TYPE {
  simpleToastr = 'simpleToastr',
  detailedToastr = 'detailedToastr',
  clickableToastr = 'clickableToastr',
  fixWithAiToastr = 'fixWithAiToastr'
}

export enum RiskoMeterEnum {
  'Conservative' = RiskOMeterValues.RISKOMETERVALUES_CONSERVATIVE,
  'Moderate' = RiskOMeterValues.RISKOMETERVALUES_MODERATE,
  'Aggressive' = RiskOMeterValues.RISKOMETERVALUES_AGGRESSIVE
}


export const RiskOMeterRev = {
  [RiskOMeterValues.RISKOMETERVALUES_CONSERVATIVE]: 'Conservative',
  [RiskOMeterValues.RISKOMETERVALUES_MODERATE]: 'Moderate',
  [RiskOMeterValues.RISKOMETERVALUES_AGGRESSIVE]: 'Aggressive',
}

export enum PlanTypeEnum {
  'OneTime'= PlanType.PLANTYPE_ONETIME,
  'Limited Period' = PlanType.PLANTYPE_LIMITED_PERIOD,
  'Forever' = PlanType.PLANTYPE_FOREVER,
}

export const allowedRiskCategories = [RiskOMeterValues.RISKOMETERVALUES_CONSERVATIVE, RiskOMeterValues.RISKOMETERVALUES_MODERATE, RiskOMeterValues.RISKOMETERVALUES_AGGRESSIVE];

export const ShowPromotePlan = 'showPromotePlan';

export enum SecondsIn {
  MINUTE = 60,
  HOUR = 3600,
  DAY = 86400
}

export const BROKER_CONNECTION_STATUS = {
  [BrokerConnectionStatus.CONNECTIONSTATUS_ACTIVE]: 'Active',
  [BrokerConnectionStatus.CONNECTIONSTATUS_LOGGEDOUT]: 'Logged Out',
  [BrokerConnectionStatus.CONNECTIONSTATUS_INACTIVE]: 'Inactive',
}
